import { render, staticRenderFns } from "./MenuReports.vue?vue&type=template&id=4c575836&scoped=true"
import script from "./MenuReports.vue?vue&type=script&lang=js"
export * from "./MenuReports.vue?vue&type=script&lang=js"
import style0 from "./MenuReports.vue?vue&type=style&index=0&id=4c575836&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c575836",
  null
  
)

export default component.exports